import React from 'react'
import { IconName } from '@fortawesome/pro-light-svg-icons'
import IconWithBackground from '../IconWithBackground/IconWithBackground' // Import the IconWithBackground component if not already imported
import { formatCurrencyValue } from '../../helpers/utils'
import styles from './PackageItem.module.scss'
import DynamicFaIcon from '../DynamicFaIcon/DynamicFaIcon'

interface PackageItemProps {
    a: {
        icon?: IconName // Replace with the actual type of the icon prop
        name: string
        description: string
        price: number // Replace with the actual type of the price prop
        products: any[]
    }
    layout: 'row' | 'block'
    inBasket?: boolean
    addProductToBasket?: (product: any, isPack: boolean) => void // Replace 'any' with the actual type of the product
    removeProductFromBasket?: (product: any, isPack: boolean) => void // Replace 'any' with the actual type of the product
}

const PackageItem: React.FC<PackageItemProps> = ({
    a,
    inBasket,
    layout = 'block',
    addProductToBasket,
    removeProductFromBasket
}) => {
    const selectedOptions = a.products
        .map((p: any) => p.availableOptions)
        .flat()
        .filter((o: any) => o._isAdded)

    return (
        <li
            className={`flex flex-grow w-full  ${
                layout === 'row' ? 'flex-row py-3 border-btm last:border-b-0' : 'flex-col border-btm lg:border-0'
            } items-center flex-1`}
        >
            <div
                className={`flex flex-wrap px-4 h-full ${
                    layout === 'row'
                        ? 'flex-row w-full space-x-3 justify-between'
                        : 'pt-4 flex-col space-y-3 text-center'
                } items-center`}
            >
                <div className={layout === 'row' ? 'w-full flex justify-between' : ''}>
                    <div
                        className={`flex ${
                            layout === 'row' ? 'flex-row items-start' : 'flex-col gap-y-2 items-center'
                        }`}
                    >
                        <IconWithBackground iconName={a.icon} />
                        <div className='flex flex-col mx-3'>
                            <span className='font-semibold block text-base my-1'>{a.name}</span>
                            <span
                                className={`text-sm text-gray-700 ${layout === 'row' ? 'text-left' : 'text-center'}`}
                                dangerouslySetInnerHTML={{ __html: a.description }}
                            ></span>
                        </div>
                    </div>

                    <span className={`block mt-1 px-4 ${layout !== 'row' && 'text-sm'}`}>
                        {formatCurrencyValue(a.price)}
                    </span>
                </div>

                <div className={`w-full pl-12 mt-2 ${layout === 'row' ? 'pr-4' : 'pr-7 '}`}>
                    {selectedOptions?.map((availableOption: any, i: number) => {
                        return (
                            <div key={i} className='w-full text-xs text-gray-500 flex justify-between gap-x-2'>
                                <span>+ {availableOption.name}</span>
                                <span className={`block ${layout === 'row' && 'text-right'}`}>
                                    {formatCurrencyValue(availableOption.price)}
                                </span>
                            </div>
                        )
                    })}
                </div>
            </div>

            {addProductToBasket && removeProductFromBasket && (
                <button
                    type='button'
                    aria-label={inBasket ? 'Verwijder pakket uit winkelmandje' : 'Voeg pakket toe aan winkelmandje'}
                    onClick={() => (inBasket ? removeProductFromBasket(a, true) : addProductToBasket(a, true))}
                    className={
                        styles.packageItemButton +
                        ' px-4' +
                        ` ${inBasket ? 'bg-opacity-10' : 'bg-opacity-0'} border-top`
                    }
                >
                    <DynamicFaIcon
                        iconName={inBasket ? 'check-circle' : 'plus-circle'}
                        iconPrefix={inBasket ? 'fas' : 'fal'}
                        className={`${inBasket && ''} text-2xl`}
                    />
                    <span className='font-semibold text-xs'>{inBasket ? 'GESELECTEERD' : 'SELECTEER'}</span>
                </button>
            )}
        </li>
    )
}

export default PackageItem
